import { useState } from "react";

export default function CabinDetails({ details, setDetails }) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div>
      <button
        onClick={() => setShowDetails(!showDetails)}
        className="my-button"
        style={{
          width: '100%',
          textAlign: 'left',
          marginBottom: '4px'
        }}
      >
        Kofre Ekle {showDetails ? '▴' : '▾'}
      </button>

      {showDetails && (
        <div className="panel-type-details-box">
          <table className="panel-type-details-table compact-table">
            <tbody>
              <tr>
                <td className="label-cell">Sayaç Sayısı</td>
                <td>
                  <input
                    type="number"
                    value={details.sayacSayisi || 1}
                    onChange={(e) =>
                      setDetails({ ...details, sayacSayisi: parseInt(e.target.value) })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td className="label-cell">Kullanım Amacı</td>
                <td>
                  <select
                    value={details.kullanimAmac}
                    onChange={(e) => setDetails({ ...details, kullanimAmac: e.target.value })}
                  >
                    <option value="Mesken">Mesken</option>
                    <option value="İş Yeri">İş Yeri</option>
                    <option value="Müşterek">Müşterek</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
